'use client';

// CreatorMessageButton - Subtle CTA to send a message to the bot's creator
// Story 4.11: Send a Message to My Creator

import Button from '@mui/material/Button';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslations } from 'next-intl';

interface CreatorMessageButtonProps {
  onClick: () => void;
  hasSent: boolean;
}

export function CreatorMessageButton({ onClick, hasSent }: CreatorMessageButtonProps) {
  const t = useTranslations('consumer.creatorMessage');

  return (
    <Button
      variant="text"
      size="small"
      onClick={onClick}
      disabled={hasSent}
      aria-live="polite"
      startIcon={hasSent ? <CheckCircleOutlineIcon /> : <MailOutlineIcon />}
      sx={{
        textTransform: 'none',
        color: hasSent ? 'text.secondary' : 'primary.main',
        fontSize: '0.8125rem',
      }}
    >
      {hasSent ? t('sent') : t('button')}
    </Button>
  );
}
